<template>
    <div>
        <b-card>
            <ValidationObserver ref="validation-observer">
                <b-row>
                    <b-col cols="12" md="6" class="px-1">
                        <ValidationProvider name="Код" rules="required" v-slot="{ errors }">
                            <b-form-group label="Код" label-for="qr-code">
                                <b-form-input
                                    id="qr-code"
                                    v-model="form.code"
                                    size="md"
                                    placeholder="QR-000001"
                                    :readonly="isSaving"
                                />
                            </b-form-group>
                            <p v-if="errors" class="validation__red">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="6" class="px-1">
                        <ValidationProvider name="Статус" rules="required" v-slot="{ errors }">
                            <b-form-group label="Статус" label-for="qr-status">
                                <b-form-select
                                    id="qr-status"
                                    v-model="form.status"
                                    :options="statusOptions"
                                    :disabled="isSaving"
                                />
                            </b-form-group>
                            <p v-if="errors" class="validation__red">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="6" class="px-1">
                        <b-form-group label="Batch ID" label-for="qr-batch-id">
                            <b-form-input
                                id="qr-batch-id"
                                v-model="form.batch_id"
                                size="md"
                                placeholder="batch-001"
                                :readonly="isSaving"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6" class="px-1">
                        <b-form-group label="Дата использования" label-for="qr-used-at">
                            <b-form-input
                                id="qr-used-at"
                                v-model="form.used_at"
                                type="datetime-local"
                                size="md"
                                :readonly="isSaving"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </ValidationObserver>

            <b-button
                class="btn-success float-right mt-2"
                @click="save"
                :disabled="isSaving"
            >
                Сохранить
            </b-button>
        </b-card>
    </div>
</template>

<script>
import {
    BFormGroup,
    BFormInput,
    BButton,
    BCard,
    BCol,
    BRow,
    BFormSelect,
} from "bootstrap-vue";
import QrCodes from "@/services/qrCodes";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const api = new QrCodes();

export default {
    name: "AppQrCodeEdit",
    components: {
        BFormGroup,
        BFormInput,
        BButton,
        BCard,
        BCol,
        BRow,
        BFormSelect,
        ToastificationContent,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            isSaving: false,
            form: {
                code: "",
                status: "new",
                batch_id: "",
                used_at: "",
            },
            statusOptions: [
                { value: "new", text: "Новый" },
                { value: "used", text: "Использован" },
                { value: "disabled", text: "Отключен" },
            ],
        };
    },
    async mounted() {
        if (this.$route.params.id) {
            await this.getRecord(this.$route.params.id);
        }
    },
    methods: {
        async getRecord(id) {
            await api.fetchOne(id)
                .then((res) => {
                    this.form = {
                        code: res.data.code || "",
                        status: res.data.status || "new",
                        batch_id: res.data.batch_id || "",
                        used_at: this.toDateTimeLocal(res.data.used_at),
                    };
                })
                .catch((error) => {
                    console.error(error);
                    this.showToast("danger", "Что-то пошло не так!", "XIcon");
                });
        },
        async save() {
            const isValid = await this.$refs["validation-observer"].validate();
            if (!isValid) {
                this.showToast("danger", "Заполните все обязательные поля!", "XIcon");
                return;
            }

            this.isSaving = true;
            const data = {
                code: this.form.code,
                status: this.form.status,
                batch_id: this.form.batch_id || null,
                used_at: this.formatDateTime(this.form.used_at),
            };

            const req = this.$route.params.id
                ? api.update(this.$route.params.id, data)
                : api.create(data);

            await req
                .then(() => {
                    this.$router.push({ name: "qr-codes" });
                    this.showToast("success", "Успешно cохранено!", "CheckIcon");
                })
                .catch((error) => {
                    console.error(error);
                    this.showToast("danger", "Что-то пошло не так!", "XIcon");
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        toDateTimeLocal(value) {
            if (!value) return "";
            const date = new Date(value);
            const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
            return offsetDate.toISOString().slice(0, 16);
        },
        formatDateTime(value) {
            if (!value) return null;
            return value.replace("T", " ") + ":00";
        },
        showToast(variant, text, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: text,
                    icon,
                    variant,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.validation__red {
    color: red;
    font-size: 12px;
    display: block;
    margin-bottom: 1rem;
}
</style>
